.aTab {
  font-size: 16px;
  display: inline-flex;
  align-items: center;

  svg {
    width: 33px;
    margin-right: 0;

    path {
      fill: var(--primitives-colors-neutral-0);
    }
  }

  @media screen and (max-width: 1200px) {
    font-size: 12px!important;
    line-height: 22px!important;
    padding: 0 11px!important;
    border-radius: var(--semantics-radius-12)!important;

    svg {
      width: 25px;
    }
  }

  @media screen and (max-width: 1020px) {
    display: none!important;
  }
}
